import { useEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Skeleton } from '@mui/material';
import { Stack } from '@mui/material';

am4core.useTheme(am4themes_animated);

const NestedDonutChart = ({ data }) => {
  const [height, setHeight] = useState();
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    setShowLoader(true);
    if (data.length) {
      const updatedChart = am4core.create('piechartdiv', am4charts.PieChart);

      updatedChart.events.on('ready', () => {
        setShowLoader(false);
      });

      updatedChart.innerRadius = am4core.percent(10);
      updatedChart.data = data;

      const years = Object.keys(data[0]);
      //setHeight(`${((years.length * data.length) / 2) * 33}px`);
      setHeight(`${((years.length * data.length) / 2) * 15}px`);
      years.forEach((el) => {
        if (el !== 'category') {
          let pieSeries = updatedChart.series.push(new am4charts.PieSeries());
          pieSeries.dataFields.name = 'el';

          pieSeries.dataFields.value = el;
          pieSeries.dataFields.category = 'category';
          pieSeries.slices.template.stroke = am4core.color('#fff');
          pieSeries.slices.template.strokeWidth = 2;
          pieSeries.slices.template.strokeOpacity = 1;

          pieSeries.slices.template.tooltipText = `${el}\n{category.formatNumber('#')} : {value.percent.formatNumber('#.0')}%\n{value}`;

          pieSeries.labels.template.disabled = true;
        }
      });

      /* Create legend */
      updatedChart.legend = new am4charts.Legend();

      /* Create a separate container to put legend in */
      let legendContainer = am4core.create('legenddiv', am4core.Container);
      legendContainer.width = am4core.percent(100);
      legendContainer.height = am4core.percent(100);
      updatedChart.legend.parent = legendContainer;
      updatedChart.legend.labels.template.maxWidth = 100;
      updatedChart.legend.labels.template.truncate = true;

      updatedChart.legend.labels.template.adapter.add('maxWidth', () => {
        return 300;
      });
      
      updatedChart.exporting.menu = new am4core.ExportMenu();
      updatedChart.exporting.menu.align = 'left';
      updatedChart.exporting.menu.verticalAlign = 'top';
    }
  }, [data]);

  return (
    <>
      <>
        <div id='piechartdiv' style={{ width: showLoader ? '0' : '100%', height: showLoader ? '0' : '500px' }}></div>
        <div
          id='legendwrapper'
          style={{
            width: showLoader ? '0' : '100%',
            height: showLoader ? '0' : height,
            maxHeight: '250px',
            border: '1px dotted #c99',
            margin: '1em 0',
            overflowX: 'none',
            overflowY: 'auto',
          }}
        >
          <div id='legenddiv' style={{ height: showLoader ? '0' : height }}></div>
        </div>
      </>

      {showLoader && (
        <Stack spacing={1}>
          <Skeleton variant='text' sx={{ fontSize: '1rem' }} />
          <Skeleton variant='rounded' width={'auto'} height={500} />
        </Stack>
      )}
    </>
  );
};

export default NestedDonutChart;
